import { jsx as _jsx } from "react/jsx-runtime";
import { Typography, Checkbox } from 'seagull';
import { useLocaleKeys } from '~/i18n';
import EditableTableCell from '../EditableTableCell/EditableTableCell';
export default function PaymentMethodRequiredCell(param) {
    let { draft, index, onOpenModal, isDisabled, disabledTooltip } = param;
    const { t } = useLocaleKeys('pages.draftsDashboard.editTable.draftCells');
    const onClick = ()=>onOpenModal({
            width: '640px',
            renderContent: (param)=>{
                let { draft, setDraft } = param;
                return {
                    title: t.paymentMethodRequired(),
                    testId: "edit-payment-method-required-modal-".concat(index),
                    content: /*#__PURE__*/ _jsx(Checkbox, {
                        testId: "edit-payment-method-required-checkbox-".concat(index),
                        checked: draft.allowWithoutPaymentMethod(),
                        onChange: ()=>setDraft(draft.setRequirePaymentMethod(draft.allowWithoutPaymentMethod())),
                        children: /*#__PURE__*/ _jsx(Typography, {
                            skin: "standard",
                            children: t.letClientApproveWithoutPaymentMethod()
                        })
                    }),
                    onSubmit: (defaultBehavior)=>{
                        defaultBehavior();
                    }
                };
            }
        });
    return /*#__PURE__*/ _jsx(EditableTableCell, {
        testId: "payment-method-required-cell-".concat(index),
        onClick: onClick,
        isDisabled: isDisabled,
        disabledTooltip: disabledTooltip,
        children: /*#__PURE__*/ _jsx(Typography, {
            ellipsis: true,
            testId: "payment-method-required-".concat(index),
            children: draft.allowWithoutPaymentMethod() ? 'Yes' : 'No'
        })
    });
}
